import { fileExtensionSchema, fileId } from "@inrev/common";
import * as z from "zod";
import { defineTool } from "../tool-definition";

/**
 * Proxy audience: `ask_document` calls this to locate a file before reading it, which is what
 * lets the agent drop its own database access. A model has no use for a storage path.
 *
 * `bucketName` stays a string because the column is typed with apps/api's nominal
 * `CloudStorageBucketName` enum, which is not assignable to a literal union without a cast.
 */
export const getFileLocation = defineTool({
	name: "get_file_location",
	description:
		"Resolve a file's storage location so a document read can fetch it. Proxy-only; not offered to the model.",
	label: "File location",
	contexts: ["account", "bond_request", "bond"],
	implementation: "api",
	audience: "proxy",
	input: z.strictObject({
		fileId,
	}),
	data: z.strictObject({
		fileId,
		name: z.string().nullable(),
		extension: fileExtensionSchema,
		bucketName: z.string(),
		bucketDirPath: z.array(z.string()).nullable(),
	}),
});
